import { createTheme } from '@mui/material';

const theme = createTheme({
    palette: {
        primary: {
            main: '#01579b', //01579b
        },
        secondary: {
            main: '#f5f5f5',
        },
        type: 'dark',
    },
    components: {
        MuiButton: {
            defaultProps: {
                size: 'small',
                color: 'info',
                sx: {
                    fontWeight: 'bolder'
                }
            }
        },
        MuiIconButton: {
            defaultProps: {
                size: 'small'
            }
        },
        MuiToolbar: {
            defaultProps: {
                variant: 'dense',
                size: 'small'
            }
        },
        MuiTextField: {
            defaultProps: {
                size: 'small',

            }
        },
        MuiTable: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiTableCell: {
            defaultProps: {
                align: 'center'
            }
        },
        MuiTableHead: {
            defaultProps: {
                style: {
                    backgroundColor: '#EEEEEE', //f0f3f5
                }
            }
        },
        MuiDialogTitle: {
            defaultProps: {
                style: {
                    backgroundColor: '#0288D1',
                    color: 'white',
                    textTransform: 'uppercase'
                },
                align: 'center'
            }
        },
        MuiDialogContent: {
            defaultProps: {
                style: {
                    paddingTop: 5
                }
            }
        },
        MuiTabs: {
            defaultProps: {
                variant: "scrollable"
            }
        },
    }
});

export default theme;